// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bb3e9e2b","239":"9c3a1c8f","732":"cc594bb2"}[chunkId] + ".chunk.js";
};